export default __webpack_public_path__ + "static/media/saudia.530609fd.svg";